import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SwitchInput } from "./SwitchInput";
import { Text } from "./Text";
import { View } from "./View";
import { AuthenticationTypes, useReauthenticationState } from "../hooks/useReauthenticationState";
import { useI18n } from "../lib/i18n";
/**
 * Allows the user to configure alternative authentication methods for local
 * authentication via PIN or biometrics based on the available device support.
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-28}
 */ export function AuthenticationSettings() {
    var $t = useI18n().$t;
    var _useReauthenticationState = useReauthenticationState(), enrolledTypes = _useReauthenticationState.enrolledTypes, supportedTypes = _useReauthenticationState.supportedTypes, enroll = _useReauthenticationState.enroll, unenroll = _useReauthenticationState.unenroll;
    function AuthStrategyUI(props) {
        function getEnableButtonText() {
            switch(props.type){
                case AuthenticationTypes.FINGERPRINT:
                    return $t({
                        id: 'AccountSettings_authentication_fingerprintLabel',
                        defaultMessage: 'Fingerprint unlock'
                    });
                case AuthenticationTypes.FACIAL_RECOGNITION:
                    return $t({
                        id: 'AccountSettings_authentication_faceLabel',
                        defaultMessage: 'Face unlock'
                    });
                case AuthenticationTypes.IRIS:
                    return $t({
                        id: 'AccountSettings_authentication_irisLabel',
                        defaultMessage: 'Iris unlock'
                    });
            }
        }
        return /*#__PURE__*/ _jsxs(View, {
            row: true,
            style: {
                justifyContent: 'space-between'
            },
            children: [
                /*#__PURE__*/ _jsx(Text, {
                    text: getEnableButtonText(),
                    weight: "semibold",
                    role: "none"
                }),
                /*#__PURE__*/ _jsx(SwitchInput, {
                    "aria-label": getEnableButtonText(),
                    showOnOff: true,
                    value: !!enrolledTypes.includes(props.type),
                    onChangeValue: function(newValue) {
                        if (newValue) {
                            void enroll();
                        } else {
                            void unenroll();
                        }
                    }
                })
            ]
        });
    }
    if (!supportedTypes.length) return null;
    var supportedType = supportedTypes[supportedTypes.length - 1];
    return /*#__PURE__*/ _jsx(View, {
        children: /*#__PURE__*/ _jsx(AuthStrategyUI, {
            type: supportedType
        }, supportedType)
    });
}
